/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
var styles = {
    logo: {
        cursor: 'pointer'
    },
    partnerLogoImage: {
        height: '40px',
        maxWidth: '150px',
        cursor: 'pointer'
    }
};
export function getPartnerLogo(_a) {
    var language = _a.language, partnerContent = _a.partnerContent;
    if (partnerContent) {
        if (language === 'en') {
            return partnerContent === null || partnerContent === void 0 ? void 0 : partnerContent.logo;
        }
        return (partnerContent === null || partnerContent === void 0 ? void 0 : partnerContent.logoAr) || (partnerContent === null || partnerContent === void 0 ? void 0 : partnerContent.logo);
    }
    return null;
}
export var getQueryParams = function (query) {
    var newQuery = {};
    if ('ncr' in query && typeof query.ncr !== 'undefined') {
        newQuery.ncr = query.ncr;
    }
    if ('partner_referer' in query)
        newQuery.partner_referer = query.partner_referer;
    return query && new URLSearchParams(newQuery);
};
function AlmosaferLogo(_a) {
    var language = _a.language, partnerContent = _a.partnerContent, query = _a.query;
    var AlmosaferLogo = "https://static-sites.almosafer.com/assets/images/svg/logos/almosafer-re-".concat((language === null || language === void 0 ? void 0 : language.toLowerCase()) || 'en', "-white.svg");
    var imgHeight = language == 'en' ? 22 : 30;
    var urlWithQueryParams = getQueryParams(query);
    var hrefWithQueryParams = "/".concat(language).concat(query && urlWithQueryParams.toString()
        ? "?".concat(urlWithQueryParams.toString())
        : '');
    if (partnerContent && (partnerContent === null || partnerContent === void 0 ? void 0 : partnerContent.logo)) {
        var logo = getPartnerLogo({ language: language, partnerContent: partnerContent });
        return (React.createElement("a", { href: hrefWithQueryParams, "data-testid": "almosafer-partner-logo", "test-id": "almosafer-partner-logo" },
            React.createElement("img", { src: logo, style: styles.partnerLogoImage })));
    }
    return (React.createElement("a", { href: hrefWithQueryParams, "data-testid": "almosafer-logo", "test-id": "almosafer-logo" },
        React.createElement("img", { style: styles.logo, src: AlmosaferLogo, width: 150, height: imgHeight })));
}
export default AlmosaferLogo;
//# sourceMappingURL=AlmosaferLogo.js.map